import { anchor } from '@lib/style/mixins/anchor';
import { centerBlock } from '@lib/style/mixins/centerBlock';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import { createMemo } from '@packages/react';
import React from 'react';
import styled from 'styled-components';

const LoadingContent = styled.div`
    & {
        z-index: 5;
        background-color: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(5px);
        ${anchor()}
        .inner {
            ${centerBlock()}
        }
    }
`;

export const DialogLoading = createMemo<{ loading?: boolean; Component?: any }>(
    ({ loading, Component }) => (
        <Fade in={loading} unmountOnExit>
            <LoadingContent>
                <div className="inner">
                    {Component ? <Component /> : <CircularProgress size={34} color={'primary'} />}
                </div>
            </LoadingContent>
        </Fade>
    ),
    {
        displayName: 'DialogLoading',
    },
);
